import { ApiClientError } from "@kalaporssi/client";

export function errorMessage(e: unknown): string {
  if (e instanceof ApiClientError) return e.message;
  if (e instanceof Error) return e.message;
  return "Tuntematon virhe.";
}

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <div className="panel error" role="alert">
      {errorMessage(error)}
    </div>
  );
}

export function Loading({ text = "Ladataan…" }: { text?: string }) {
  return (
    <p className="muted" role="status">
      {text}
    </p>
  );
}
